// extracted by mini-css-extract-plugin
export default {"discount":"UqhvEc","cat":"ILJxDI","mobile":"jRcpZa","buy-content-wrapper":"FPqt1z"};